import React from 'react';
import { withRouter } from 'react-router-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Footer from '~/components/footer/index';
import { withAlert } from 'react-alert';

import { getProductData, getSimilarProducts } from '~/assets/requests/firebase';
import { getMessage, system_lang, buttonBeforeLoading, buttonToLoading, convertCentsToFloat } from '~/assets/utils';
import { addProductToFavorites, removeFromFavorites } from '~/assets/requests/product';
import { userFavorites } from '~/assets/requests/user';
import * as currencyFormatter from 'currency-formatter';

import { addProductToCart } from '~/assets/requests/product';

import './css/product.css';
import { connect } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { getFirebaseData } from '~/firebase/functions';
const sliderToShowTotal = () => {
    if (window.screen.width >= 1366) return 4;
    if (window.screen.width >= 992 && window.screen.width <= 1280) return 3;
    if (window.screen.width > 640 && window.screen.width <= 768) return 2;
    if (window.screen.width <= 640) return 2;
    return 3;
}
class Product extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            product: {},
            weights: [],
            colors: [],
            favourites: [],
            product_id: '',
            message_load: 'loading_product',
            loaded: false,
            attributes_selected: [],
            settings_carousel: {
                showThumbs: true,
                showIndicators: false,
                showStatus: false,
                emulateTouch: true,
                useKeyboardArrows: true,
                autoPlay: false,
                infiniteLoop: false
            },
            settings_carousel_similar: {
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: sliderToShowTotal(),
                slidesToScroll: sliderToShowTotal(),
                beforeChange: () => false,
                afterChange: () => false
            },
            similar_products: [],
            hovers: [],
            selectedItem: null,
            colorKey: null,
            colorsAttributes: [],
            hasImages: false
        }

        this.loadProductImages = () => {
            try {
                const { product } = this.state;
                if (Object.keys(product).length === 0) return false;
                let product_images = [];
                product['images'].filter(item => {
                    if (this.state.colorKey === item.colorKey) {
                        return item;
                    }
                    else if (!this.state.colorKey) {
                        return item;
                    }
                    else {
                        const indexOf = product['images'].findIndex(item2 => item2.colorKey === this.state.colorKey);
                        if (indexOf < 0) {
                            item.urlNotFound = process.env.PUBLIC_URL + '/images/no-product-image.png';
                            return item;
                        }
                    }
                }).map((image, key) => {
                    product_images.push(
                        <div className='slider-product position-relative' key={key}>
                            <img className='img-fluid' src={image.url} alt={product.name} />
                        </div>
                    );
                    return true;
                });

                return product_images;
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        this.updateState = () => {
            let url = window.location.pathname.split('/');
            if (url.length < 3 || url[2].length === 0) {
                this.props.history.push('/404');
            }
            this.setState({ product_id: url[2] });
        };
        this.getProductData = async () => {
            try {
                const { product_id } = this.state;
                let productData = await getProductData(product_id);
                if (productData.status === true) {
                    productData.product.favorite = false;
                    if (localStorage.getItem('user_id')) {
                        let responseFavorites = await userFavorites(localStorage.getItem('user_id'));
                        if (responseFavorites.status === true) {
                            let indexProduct = responseFavorites.favorites.indexOf(product_id);
                            if (indexProduct >= 0) productData.product.favorite = true;
                        }
                    }
                    let colorKey = null;
                    if (productData.colors.length > 0) {
                        colorKey = productData.colors[0].colorKey;
                    }
                    this.setState({
                        product: productData.product,
                        weights: productData.weights,
                        colors: productData.colors,
                        colorKey,
                        message_load: 'loading_similar_products'
                    }, () => {
                        this.setState({hasImages: this.hasImages()});
                    });
                    this.getSimilarProducts();
                } else {
                    this.props.history.push('/404');
                }
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        /**
         * Pega a chave de uma cor a partir do atributo selecionado
         * @param {*} attributeKey 
         */
        this.getColorKey = (attributeKey, childrenKey) => {
            const { colors } = this.state;
            if (!colors) return false;
            const color = colors.find(item => item.attributeKey === attributeKey && item.childrenKey === childrenKey);
            if (color) {
                if (color.key !== this.state.colorKey) {
                    return color.key;
                }
                else {
                    return this.state.colorKey;
                }
            }
            else {
                return false;
            }
        }
        this.addToCart = async () => {
            try {
                buttonToLoading('btn-action-product');
                const { product_id, attributes_selected } = this.state;
                if (attributes_selected.length === 0) {
                    this.props.alert.show('Escolha ao menos 1 item');
                    buttonBeforeLoading('btn-action-product');
                    return false;
                }

                let attributes = [];
                attributes_selected.map(item => {
                    console.log(item);

                    attributes.push({
                        ...item,
                        quantity: parseInt(item.quantity)
                    })
                })

                await addProductToCart({
                    product_id,
                    attributes_selected: attributes
                });
                setTimeout(() => {
                    buttonBeforeLoading('btn-action-product');
                    this.props.history.push('/');
                }, 200)
            }
            catch (error) {
                this.props.alert.error(error.mesage);
                return;
            }
        }
        this.addToFavorites = async () => {
            try {
                if (!localStorage.getItem('user_id')) {
                    this.props.history.push('/login');
                }
                const { product } = this.state;
                buttonToLoading('btn-favorites');
                if (product.favorite) {
                    let response = await removeFromFavorites(product._id);
                    if (response.status === true) {
                        product.favorite = false;
                    }
                } else {
                    let response = await addProductToFavorites(product._id);
                    if (response.status === true) {
                        product.favorite = true;
                    }
                }
                this.setState({ product });
                buttonBeforeLoading('btn-favorites');
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        this.seeProduct = (product_id, e) => {
            try {
                e.preventDefault();
                this.props.history.push('/product/' + product_id);
                this.setState({ product_id: product_id, loaded: false, message_load: 'loading_product', hasImages: false });
                setTimeout(async () => {
                    try {
                        window.scrollTo(0, 0);
                    } catch (error) {

                    }
                    await this.updateState();
                    this.getProductData();
                }, 500);
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        this.handleChangeProductAttribute = (attributeId, attributeValue) => {
            try {
                const { attributes_selected } = this.state;
                const pushAttributes = () => {
                    attributes_selected.push({
                        _id: attributeId,
                        value: attributeValue,
                        colorKey: this.getColorKey(attributeId, attributeValue)
                    });
                }
                if (attributes_selected.length > 0) {
                    let indexSelected = attributes_selected.findIndex(item => item._id === attributeId);
                    if (indexSelected >= 0) {
                        attributes_selected[indexSelected].value = attributeValue;
                        if (this.state.colorKey)
                            attributes_selected[indexSelected].colorKey = this.getColorKey(attributeId, attributeValue);
                    } else {
                        pushAttributes();
                    }
                } else {
                    pushAttributes();
                }
                this.setState({ attributes_selected });
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        /**
         * Remove uma quantidade selecionada
         * @param {*} item 
         */
        this.subtractProduct = (itemData) => {
            try {
                if (!this.state.colorKey) return false;

                let attributes_selected = Object.assign([], this.state.attributes_selected);
                if (attributes_selected.length === 0) {
                    return false;
                }
                else {
                    const indexOf = attributes_selected.findIndex(item => {
                        return item.colorKey === itemData.colorKey && item.childrenKey === itemData.childrenKey;
                    });
                    if (indexOf < 0) {
                        return false;
                    }
                    else if (attributes_selected[indexOf].quantity > 0) {
                        attributes_selected[indexOf].quantity -= 1;
                        if (attributes_selected[indexOf].quantity === 0) {
                            attributes_selected.splice(indexOf, 1);
                        }
                    }
                }
                this.setState({ attributes_selected });
            }
            catch (error) {
                return false;
            }
        }
        /**
         * Altera o total de atributos selecionados
         * @param {*} e 
         */
        this.changeTotalSelected = (e, itemData) => {
            try {
                if (!this.state.colorKey) {
                    this.props.alert.show('Selecione uma cor primeiro');
                    return false
                };
                let attributes_selected = Object.assign([], this.state.attributes_selected);
                if (e.target.value === '-1') {
                    e.target.value = 0;
                }
                if (attributes_selected.length === 0) {
                    attributes_selected.push({
                        attributeName: itemData.attributeName,
                        attributeKey: itemData.attributeKey,
                        childrenKey: itemData.childrenKey,
                        childrenName: itemData.childrenName,
                        quantity: parseInt(e.target.value),
                        colorKey: this.state.colorKey
                    });
                }
                else {
                    const indexOf = attributes_selected.findIndex(item => {
                        return item.colorKey === this.state.colorKey && item.childrenKey === itemData.childrenKey;
                    });
                    if (indexOf < 0) {
                        attributes_selected.push({
                            attributeName: itemData.attributeName,
                            attributeKey: itemData.attributeKey,
                            childrenKey: itemData.childrenKey,
                            childrenName: itemData.childrenName,
                            quantity: e.target.value,
                            colorKey: this.state.colorKey
                        });
                    }
                    else {
                        attributes_selected[indexOf].quantity = parseInt(e.target.value);
                        if (attributes_selected[indexOf].quantity > itemData.quantity) {
                            attributes_selected[indexOf].quantity = itemData.quantity;
                        }
                        if (attributes_selected[indexOf].quantity === 0) attributes_selected.splice(indexOf, 1);
                    }
                }
                this.setState({ attributes_selected });
            }
            catch (error) {
                return false;
            }
        }
        /**
         * Adiciona uma quantidade selecionada
         * @param {*} item 
         */
        this.addProduct = (itemData) => {
            try {
                if (!this.state.colorKey) return false;
                let attributes_selected = Object.assign([], this.state.attributes_selected);
                if (attributes_selected.length === 0) {
                    attributes_selected.push({
                        attributeName: itemData.attributeName,
                        attributeKey: itemData.attributeKey,
                        childrenKey: itemData.childrenKey,
                        childrenName: itemData.childrenName,
                        quantity: 1,
                        colorKey: this.state.colorKey
                    });
                }
                else {
                    const indexOf = attributes_selected.findIndex(item => {
                        return item.colorKey === this.state.colorKey && item.childrenKey === itemData.childrenKey;
                    });
                    if (indexOf < 0) {
                        attributes_selected.push({
                            attributeName: itemData.attributeName,
                            attributeKey: itemData.attributeKey,
                            childrenKey: itemData.childrenKey,
                            childrenName: itemData.childrenName,
                            quantity: 1,
                            colorKey: this.state.colorKey
                        });
                    }
                    else if (attributes_selected[indexOf].quantity < itemData.quantity) {
                        attributes_selected[indexOf].quantity += 1;
                    }
                }
                this.setState({ attributes_selected });
            }
            catch (error) {
                return false;
            }
        }
        /**
         * Verifica o total de itens selecionados
         * @param {*} item 
         */
        this.getAttributeTotal = (itemData) => {
            try {
                const { colorKey, attributes_selected } = this.state;
                if (!colorKey || attributes_selected.length === 0) return 0;

                const indexOf = attributes_selected.findIndex(item => {
                    return item.colorKey === colorKey && item.childrenKey === itemData.childrenKey;
                });
                if (indexOf < 0) return 0;

                return attributes_selected[indexOf].quantity;

            }
            catch (error) {
                return 0;
            }
        }
        this.renderAttributes = () => {
            try {
                const { weights, colors } = this.state
                if (weights.length === 0) return false;
                if (colors.length === 0) return false;

                let listaDeAtributos = [];
                weights.map(item => {
                    listaDeAtributos.push({
                        attributeName: 'Tamanho',
                        attributeKey: item.attributeKey,
                        childrenKey: item.childrenKey,
                        childrenName: item.name
                    });
                });
                return (
                    <div className='attribute-wrapper'>
                        <div className='row'>
                            <div className='col-12 col-lg-9 pl-lg-0'>
                                <ul className='lista-de-atributos'>
                                    {listaDeAtributos.map((item, key) => {
                                        return (
                                            <li key={key}>
                                                <div className='counter d-flex'>
                                                    <div className='counter-total'>
                                                        <input
                                                            type='number'
                                                            value={this.getAttributeTotal(item)}
                                                            name={new Date().getTime()}
                                                            onChange={(e) => this.changeTotalSelected(e, item)} />
                                                    </div>
                                                </div>
                                                <span>{item.childrenName}</span>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                );
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        /**
         * Carrega a imagem do produto
         * @param {*} product 
         * @param {*} product_id 
         */
        this.productImage = (product, product_id) => {
            try {
                if (this.state.hovers.includes(product_id)) {
                    return ((product.images[1] && product.images[1].url) || product.images[0].url);
                }
                else {
                    return product.images[0].url;
                }
            }
            catch (error) {
                return false;
            }
        }
        /**
         * Remove o hover do produto
         * @param {*} product_id 
         */
        this.onProductLeve = (product_id) => {
            try {
                if (this.state.hovers.length > 0) {
                    const indexOf = this.state.hovers.findIndex(item => item === product_id);
                    if (indexOf >= 0) {
                        const hovers = Object.assign([], this.state.hovers);
                        hovers.splice(indexOf, 1);
                        this.setState({ hovers });
                    }
                }
            }
            catch (error) {
                return false;
            }
        }
        /**
         * Remove o enter de um produto
         * @param {*} product_id 
         */
        this.onProductEnter = (product_id) => {
            try {
                if (this.state.hovers.length > 0) {
                    if (this.state.hovers.findIndex(item => item === product_id) < 0) {
                        const hovers = Object.assign([], this.state.hovers);
                        hovers.push(product_id);
                        this.setState({ hovers });
                    }
                }
                else {
                    const hovers = Object.assign([], this.state.hovers);
                    hovers.push(product_id);
                    this.setState({ hovers });
                }
            }
            catch (error) {
                return false;
            }
        }
        this.loadSimilarProducts = () => {
            try {
                let listSimilar = [];
                const { similar_products, product_id } = this.state;
                similar_products.filter(item => {
                    if (item._id !== product_id) return item;
                }).map((product, key) => {
                    listSimilar.push(
                        <a className='similar-product cursor-pointer mb-0' href={process.env.REACT_APP_URL + '/product/' + product._id} key={key} onClick={(e) => this.seeProduct(product._id, e)}>
                            <div className='similar-product-img'
                                onMouseOver={() => this.onProductEnter(product._id)}
                                onMouseOut={() => this.onProductLeve(product._id)}>
                                <LazyLoadImage
                                    alt={product.name}
                                    height={152}
                                    width={'auto'}
                                    effect="blur"
                                    src={this.productImage(product, product._id)} />
                            </div>
                            <div className='similar-product-details'>
                                <div className='similar-product-name pl-3 pr-3 pb-2 text-center'>{product.name}</div>
                                {product.showPrice === true &&
                                    <div className='similar-product-price pl-3 pr-3 pb-1 text-center'>{product.price && currencyFormatter.format(convertCentsToFloat(product.price), { locale: system_lang })}</div>
                                }
                            </div>
                        </a>
                    );
                    return true;
                });

                return listSimilar;
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        this.getSimilarProducts = async () => {
            try {
                const { product } = this.state;
                if (product.categories) {
                    let categoryRand = product.categories[Math.floor(Math.random() * product.categories.length)];
                    let response = await getSimilarProducts(categoryRand._id);
                    if (response.status === true) {
                        this.setState({ similar_products: response.products });
                    }
                }
                this.setState({ message_load: 'all_is_ready', loaded: true });
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
    }
    /**
     * Seleciona uma cor
     * @param {*} colorKey 
     */
    chooseColor = (colorKey) => {
        if (this.state.colorKey === colorKey) {
            this.setState({ colorKey: null });
        }
        else {
            this.setState({ colorKey: colorKey });
        }
    }

    /**
     * Retorna a classe formatada do elemento
     * @param {*} colorKey 
     */
    palhetaClass = (colorKey) => {
        if (colorKey === this.state.colorKey) {
            return 'palheta-cor active';
        }
        else {
            return 'palheta-cor';
        }
    }

    /**
     * Verifica se foram adicionadas imagens
     * @returns boolean
     */
    hasImages = () => {
        try {
            const { colors } = this.state;

            const total = colors.filter(item => {
                const indexOf = this.state.product.images.findIndex(item2 => item2.colorKey === item.colorKey);
                if (indexOf >= 0) {
                    return item;
                }
            }).length;

            if (total > 0) return true;

            return false;
        }
        catch (error) {
            return false;
        }
    }

     /**
     * Retorna thumbnail da cor
     * @param {*} colorKey 
     */
    colorTumbnail = (colorKey) => {
        try {
            let thumbnail = process.env.PUBLIC_URL + '/images/no-product-image.png';

            const images = this.state.product.images.filter(item => item.colorKey === colorKey);

            if(images.length > 0) {
              thumbnail = images[0].url
            }

            return thumbnail;
        } catch (error) {
            return process.env.PUBLIC_URL + '/images/no-product-image.png';
        }
    }

    /**
     * Renderiza a opção de cores
     */
    renderColors = () => {
        try {
            const { colors } = this.state;
            if (colors.length === 0) return false;

            let html = [];

            colors.map((item, key) => {
                html.push(
                    <div
                        className={this.palhetaClass(item.colorKey)}
                        style={{ backgroundColor: '#f1f1f1d9' }}
                        key={key} onClick={() => this.chooseColor(item.colorKey)}>
                        <div className="color-thumbnail">
                             <img className="img-fluid" src={this.colorTumbnail(item.colorKey)} alt=""/>
                        </div>
                        <div className='color-name' style={{ padding: '5px', backgroundColor: '#F1F1F1', borderTop: 'solid 1px #cecece' }}>
                            {item.name}
                        </div>
                    </div>
                );
            });
            return (
                <div className='attribute-content'>
                    <label className='attribute-label'>Cores</label>
                    {html}
                </div>
            );
        }
        catch (error) {
            return false;
        }
    }

    async componentDidMount() {
        try {
            window.screenTop(0, 0);
        } catch (error) {

        }
        await this.updateState();
        this.getProductData();
    }

    render() {
        const { settings_carousel, loaded, product, similar_products, settings_carousel_similar, colors, weights, hasImages } = this.state;
        return (
            <>
                <div className='container-page container-fluid show mt-2 pt-4 pb-4 mb-5'>
                    <main>
                        <div className='product-content container mb-4'>
                            <div className='row'>
                                <div className='col-12 col-lg-7'>
                                    {loaded === false
                                        ?
                                        <Skeleton className='wrapper-carousel-product' height={300} />
                                        :
                                        <Carousel
                                            className='wrapper-carousel-product'
                                            {...settings_carousel}>
                                            {this.loadProductImages()}
                                        </Carousel>}
                                </div>
                                <div className='col-12 col-lg-5'>
                                    <div className='wrapper-product-info w-100'>
                                        <h1 className='title-product-info h5 mb-3'>{loaded === false ? <Skeleton width='150px' height='25px' /> : product.name}</h1>
                                        <p className='ml-auto mr-auto description-product-info mb-2'>{loaded === false ? <Skeleton width='150px' height='25px' /> : product.description}</p>
                                        {loaded === true &&
                                            <div className='product-metric-details w-100'>{this.renderAttributes()}</div>
                                        }
                                        {(loaded === true && hasImages == true) &&
                                            <div className='product-metric-details w-100'>{this.renderColors()}</div>
                                        }
                                        {(loaded === true && product.showPrice === true && hasImages === true) &&
                                            <div className='price-product-info h2'>{currencyFormatter.format(convertCentsToFloat(product.price), { locale: system_lang })}</div>
                                        }
                                        <div className='mb-2'></div>
                                        <div className='product-actions w-100 d-md-flex d-xl-block flex-wrap'>
                                            {(colors.length > 0 && weights.length > 0 && product.showPrice === true && loaded === true && hasImages === true) &&
                                                <div className='button-actions mb-2 mr-0 mr-md-3 mr-xl-0' style={{margin: '0 -5px'}}>
                                                    <button className='btn btn-secondary btn-action-product' onClick={this.addToCart}>{getMessage('add_to_cart')}</button>
                                                </div>
                                            }
                                            <div className='button-actions' style={{margin: '0 -5px'}}>
                                                <button className='btn btn-action-default btn-favorites' onClick={this.addToFavorites}>{getMessage(product.favorite === false ? 'add_to_favorites' : 'remove_from_favorites')}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='product-details container'></div>
                        {similar_products.filter(item => item._id !== this.state.product_id).length > 0 &&
                            <div className='similar-products container'>
                                <div className='similar-product-title pt-4 pb-2'>{getMessage('maybe_you_like_it_products')}</div>
                                <Slider className='mr-md-3 ml-md-3' {...settings_carousel_similar}>{this.loadSimilarProducts()}</Slider>
                            </div>
                        }
                    </main>
                </div>
                <Footer />
            </>
        )
    }
}
export default withRouter(connect(store => ({ products: store.products, user: store.user }))(withAlert()(Product)));